import { trackPromise } from 'react-promise-tracker';
import { getPcpDetailsService } from '../../services/yourCareTeamService';
import constants from './constants';

export const setValue = (data) => {
    return {
      type: constants.SET_VALUE,
      payload: data
    };
  };

  export const setValueCleanUp = () => ({
    type: constants.SET_CLEANUP
});

export const setPcpDetailsBegin = payload => ({
    type: constants.SET_PCP_DETAILS_BEGIN,
    payload
});

export const setPcpDetailsSuccess = payload => ({
    type: constants.SET_PCP_DETAILS_SUCCESS,
    payload
});
export const setPcpDetailsCleanUp = () => ({
    type: constants.SET_PCP_CLEANUP
});

export const setPcpDetailsError = payload => ({
    type: constants.SET_PCP_ERROR,
    payload
});

export const getPcpDetails = (memberAccount, tenantId) => {
    return (dispatch) => {
        trackPromise(
            getPcpDetailsService(memberAccount, tenantId)
                .then(res => dispatch(setPcpDetailsSuccess(res.data)))
                .catch(err => dispatch(setPcpDetailsError(err)))
        );
    };
};